import { FaAws, FaBootstrap, FaNodeJs, FaSass } from "react-icons/fa";
import { BsGit } from "react-icons/bs";
import {
  SiHtml5,
  SiMongodb,
  SiCss3,
  SiTailwindcss,
  SiFramer,
  SiJavascript,
  SiTypescript,
  SiReact,
  SiNestjs,
  SiDocker,
  SiFigma,
  SiPython,
  SiPostgresql,
} from "react-icons/si";
//import { BubbleIcon } from "./bubbleIcon.js";

export const icons = [
  {
    name: "html",
    iconName: <SiHtml5 />,
  },
  {
    name: "css",
    iconName: <SiCss3 />,
  },
  {
    name: "sass",
    iconName: <FaSass />,
  },
  {
    name: "bootstrap",
    iconName: <FaBootstrap />,
  },
  {
    name: "tailwind",
    iconName: <SiTailwindcss />,
  },
  {
    name: "git",
    iconName: <BsGit />,
  },
  {
    name: "js",
    iconName: <SiJavascript />,
  },
  {
    name: "typescript",
    iconName: <SiTypescript />,
  },
  {
    name: "react",
    iconName: <SiReact />,
  },
  {
    name: "motion",
    iconName: <SiFramer />,
  },
  {
    name: "figma",
    iconName: <SiFigma />,
  },
  {
    name: "node",
    iconName: <FaNodeJs />,
  },
  {
    name: "nest",
    iconName: <SiNestjs />,
  },
  {
    name: "python",
    iconName: <SiPython />,
  },
  {
    name: "docker",
    iconName: <SiDocker />,
  },
  {
    name: "mongo",
    iconName: <SiMongodb />,
  },
  {
    name: "postgres",
    iconName: <SiPostgresql />,
  },
  {
    name: "aws",
    iconName: <FaAws />,
  },
];
